import React, { useState } from "react";
import "./PricingCard.css"; // même style que PricingCard

const CustomPricingCard = ({ title, image, features, buttonText }) => {
  const [customPrice, setCustomPrice] = useState("");

  const handlePayment = async () => {
    if (!customPrice || isNaN(customPrice) || Number(customPrice) <= 0) {
      alert("Veuillez saisir un prix valide !");
      return;
    }

    try {
      const res = await fetch("https://stratedgeos.lu/create-payment-mollie.php", {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ pack: title, amount: customPrice })
      });

      const data = await res.json();

      if (data.url) {
        console.log({ pack: title, amount: customPrice });
        window.location.href = data.url; // redirection vers Mollie
      }
    } catch (error) {
      console.error("Erreur paiement:", error);
    }
  };

  return (
    <div
      className="card shadow-sm rounded-4 overflow-hidden"
      style={{ width: "18rem" }}
    >
      <div className="card-body text-center">
        <h5 className="card-title fw-bold mb-2">{title}</h5>
        <input
          type="number"
          className="form-control mb-3 text-center"
          placeholder="Saisir prix (€)"
          value={customPrice}
          onChange={(e) => setCustomPrice(e.target.value)}
          min="0"
        />
        {image && (
          <img
            src={image}
            alt={title}
            className="img-fluid mb-3"
            style={{ maxHeight: "150px", objectFit: "contain" }}
          />
        )}
        <hr />
        <ul className="list-unstyled mt-3 mb-4 text-start px-3">
     
        </ul>
        <button
          className="btn btn-primary rounded-pill px-4 py-2"
          style={{ backgroundColor: "#003466", border: "none" }}
          onClick={handlePayment}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default CustomPricingCard;
